// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Rk8w3","container__icon":"styles_container__icon__erQ0v","skeleton-animation":"styles_skeleton-animation__7m7qA"};